import { gql } from "@apollo/client"

export const DELETE_MEDIA = gql`
  mutation DeleteMedia($ids: [ID]!) {
    deleteMedia(ids: $ids) {
      response
    }
  }
`
